import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { DateTimeManager } from './../Common/DateTimeManager.js';
import axios from 'axios'

import { api, getTicketTypeInfosByTicketTypeId, getAddressOfOrder } from 'ticketino-api-client';

import "react-datepicker/dist/react-datepicker.css";

import Navbar from './components/Navbar'
import Header from './components/Header'

import UseStateContext from './session/UseStateContext'

const SessionCheckin = () => {
    const { context, resetContext, setContext } = UseStateContext();
    const [lead, setLead] = useState({});
    const [selectedSession, setSelectedSession] = useState([]);

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    const {
        salutation,
        firstname,
        lastname,
        company,
        companyFunction,
        street,
        postCode,
        city,
        telephone,
        email,
        projectRequest,
        customerStatus
    } = lead;


    let navigate = useNavigate();
    let baseUrl = "https://api.ticketino.com";

    const { uniqueKey } = useParams();
    let hasSubmittedRef = React.useRef(false);


    useEffect(() => {
        const storedSession = sessionStorage.getItem("selectedSession");
        if (storedSession) {
            setSelectedSession(storedSession);
        }
    }, []);

    useEffect(() => {
        if (
            lead.ticketId &&
            selectedSession &&
            typeof selectedSession === 'string' &&
            selectedSession.length > 0 &&
            !hasSubmittedRef.current
        ) {
            hasSubmittedRef.current = true; // prevent future runs
            autoSubmitLead();
        }
    }, [lead, selectedSession]);

    useEffect(() => {
        if (!(uniqueKey > 0)) {
            setError(true);
        }
    }, [uniqueKey]);

    useEffect(() => {
        setContext({ uniqueKey: uniqueKey });

        loadToken()
    }, [uniqueKey]);

    const loadToken = async () => {
        await axios.get("Ticketino/Token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            if (uniqueKey > 0) {
                loadTicket(uniqueKey);
            }
        }).catch((error) => {
            logout();
            setError(true);
            setLoading(false);
        })
    }

    const loadTicket = async (uniqueKey) => {
        try {
            setLoading(true);
            setError(false);

            const ticket = await requestTicketByUniqueKey(uniqueKey);

            const ticketTypeInfo = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);

            const ticketTypeName = ticketTypeInfo.find(tti => tti.languageId == 0)?.name;

            const orderAddress = await getAddressOfOrder(ticket.orderId);

            let updatedLead = {
                salutation: orderAddress.salutation,
                firstname: orderAddress.firstName,
                lastname: orderAddress.name,
                company: orderAddress.company,
                companyFunction: orderAddress.function,
                street: orderAddress.street,
                postCode: orderAddress.postCode,
                city: orderAddress.city,
                telephone: orderAddress.telephone,
                email: orderAddress.email,
                customerNumber: orderAddress.code1,
                status: ticket.option11 ?? "",
                ticketId: ticket.id,
                ticketName: ticketTypeName,
                customerStatus: orderAddress.code4,
                projectRequest: "session-checkin"
            }

            setLead(updatedLead);
            setLoading(false);
        }
        catch (error) {
            setError(true);
            setLoading(false);
            console.error(error);
        }
    }

    const requestTicketByUniqueKey = async (uniqueKey) => {
        try {
            const res = await axios.get(`${baseUrl}/Ticket?uniqueKey=${uniqueKey}`);
            return res.data;
        } catch (error) {
            console.error(error);
        }
    }

    const logout = () => {
        axios.post("/Logout").then(() => {
            sessionStorage.removeItem("selectedSession");
            resetContext();
            navigate("/login");
        })
    }

    const autoSubmitLead = async () => {
        let body = {
            ...lead,
            exhibitorId: context.exhibitor?.id,
            standNumber: context.exhibitor?.standNumber,
            company: company,
            salutation: salutation,
            firstname: firstname,
            lastname: lastname,
            companyFunction: companyFunction,
            phone: telephone,
            email: email,
            street: street,
            postCode: postCode,
            region: city,
            customerStatus: customerStatus,
            projectRequest: projectRequest,
            customerNumber: lead.customerNumber,
            status: lead.status,
            ticketId: lead.ticketId,
            scanner: context.scanner,
            ticketName: lead.ticketName,
            session: selectedSession
        }

        axios.post(`/Lead`, body).then(() => {
            setContext({ lead: lead });
            navigate("/success");
        });
    }

    return (
        <>
            <Navbar />
            <div className="container mt-4 page-container">
                <Header />
            </div>
        </>
    )
}

export default SessionCheckin